/** Cuts to `maxLength` UTF-16 units, as the shell's schemas count, without leaving half a surrogate pair. */
export function clampBridgeString(value: string, maxLength: number): string {
  const cut = value.slice(0, maxLength);
  return /[\uD800-\uDBFF]$/.test(cut) ? cut.slice(0, -1) : cut;
}
